import { loaderSelector } from "../../../hooks/store/getters";
import styles from "./Loader.module.css"
import { useAppStore } from "../../../hooks/store/useAppStore";
import Spinner from 'react-bootstrap/Spinner';
import Logo from "../logo/Logo";

const Loader = ({ show=false }) => {
    const loading = useAppStore(loaderSelector);

    if(!loading && !show) {
        return null
    }
    
    return(
        <div className={styles.appLoader}>
            <div className={styles.logoSpinner}>
                <Logo />
                <Spinner className={styles.spinner} animation="border" role="status" variant="primary" />
            </div>
            
            <span className={styles.loaderText}>{loading}</span>
        </div>
       
    )
    

}

export default Loader;